<template>
  <div class="search">
    <div class="search-bar-main">
      <div class="search-bar">
        <!-- 关键字搜索 -->
        <el-input v-model="formdata.keywords" :placeholder="$t('cart.cart30')"
          @keyup.enter.native="onSearch" clearable></el-input>
        <el-upload ref="uploadRef" :showFileList="false" action="#" :limit="1" accept="image/*"
          :http-request="handleImageUpload" :before-upload="beforeUpload">
          <template #trigger>
            <div class="flex-center search-icon" style="margin-right: 10px;">
              <i class="el-icon-camera-solid camera-icon" :class="{ 'is-loading': uploading }"></i>
            </div>
          </template>
        </el-upload>
        <div class="right-search-btn btn-blue" @click="onSearch">
          <b style="color: white">{{ $t("common.search") }}</b>
        </div>
      </div>
    </div>
    <div v-if="recentKeywords.length" class="recent-search">
      <span class="recent-label">{{ $t('cart.cart31') }}</span>
      <div class="recent-tags">
        <span class="recent-tag" v-for="kw in recentKeywords" :key="kw" @click="onClickKeyword(kw)">{{ kw }}</span>
      </div>
    </div>
  </div>
</template>

<script>
const imageSearchCache = {
  file: null,
  imageIds: {
    '1688': null,
    taobao: null
  }
};

export default {
  name: "Search",
  props: {
    activeName: {
      type: String,
      default: "1688"
    }
  },
  data() {
    return {
      uploading: false,
      formdata: {
        goodsUrl: undefined,
        keywords: undefined,
        sortKey: 1,
      },
      compressedFile: null,
      recentKeywords: []
    };
  },
  created() {
    // 从路由 query 回填关键词（goodslist 页面使用）
    if (this.$route.query.keywords) {
      this.formdata.keywords = this.$route.query.keywords;
    }
    this.loadHistory();
  },
  methods: {
    getHistoryUserId() {
      return sessionStorage.getItem('userId') || localStorage.getItem('userId');
    },
    loadHistory() {
      const stored = localStorage.getItem('recentSearchKeywords');
      if (!stored) {
        return;
      }
      try {
        const allHistory = JSON.parse(stored) || {};
        const userId = this.getHistoryUserId();
        this.recentKeywords = allHistory[userId] || [];
      } catch (e) {
        this.recentKeywords = [];
      }
    },
    saveKeyword(keyword) {
      const trimmedKeyword = (keyword || '').trim();
      if (!trimmedKeyword || trimmedKeyword.includes('http')) {
        return;
      }
      const userId = this.getHistoryUserId();
      if (!userId) {
        return;
      }

      try {
        const stored = localStorage.getItem('recentSearchKeywords');
        const allHistory = stored ? JSON.parse(stored) || {} : {};
        const userKeywords = allHistory[userId] || [];
        const filteredKeywords = userKeywords.filter(keyword => keyword !== trimmedKeyword);
        filteredKeywords.unshift(trimmedKeyword);
        allHistory[userId] = filteredKeywords.slice(0, 6);
        localStorage.setItem('recentSearchKeywords', JSON.stringify(allHistory));
        this.recentKeywords = allHistory[userId];
      } catch (e) {
        this.recentKeywords = [];
      }
    },
    onClickKeyword(keyword) {
      this.formdata.keywords = keyword;
      this.onSearch();
    },
    onSearch() {
      const keywords = this.formdata.keywords || '';
      this.saveKeyword(keywords);
      if (keywords.includes("http")) {
        this.formdata.goodsUrl = keywords;
        this.$router.push({
          name: "goodsDetail",
          query: { goodsUrl: keywords, platform: 'URL' },
        });
      } else {
        this.$emit('search')
        this.$router.push({
          name: "cartDetail",
          query: { platform: this.activeName, keywords },
        }).catch(() => {});
      }
    },
    compressImage(file, quality = 0.6, maxWidth = 150) {
      return new Promise((resolve) => {
        console.log(`图片压缩前大小: ${(file.size / 1024).toFixed(2)} KB`); // 打印压缩前大小
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (event) => {
          if (typeof event.target?.result === "string") {
            const img = new Image();
            img.src = event.target.result;
            img.onload = () => {
              const canvas = document.createElement("canvas");
              const ctx = canvas.getContext("2d");

              // 检查 ctx 是否为 null
              if (!ctx) {
                console.error("Failed to get 2D context for canvas.");
                resolve(file); // 如果获取失败，直接返回原文件
                return;
              }

              // 计算缩放比例
              const scale = maxWidth / img.width;
              const width = img.width * scale;
              const height = img.height * scale;

              // 设置 canvas 尺寸
              canvas.width = width;
              canvas.height = height;

              // 绘制图片到 canvas
              ctx.drawImage(img, 0, 0, width, height);

              // 将 canvas 转换为 Blob
              canvas.toBlob(
                (blob) => {
                  if (blob) {
                    const compressedFile = new File([blob], file.name, {
                      type: file.type,
                      lastModified: Date.now(),
                    });
                    console.log(`图片压缩后大小: ${(compressedFile.size / 1024).toFixed(2)} KB`); // 打印压缩后大小
                    resolve(compressedFile);
                  } else {
                    console.warn("Failed to create blob from canvas.");
                    resolve(file); // 如果创建 blob 失败，直接返回原文件
                  }
                },
                file.type,
                quality
              );
            };
          } else {
            console.error("Failed to read image data as URL.");
            resolve(file); // 如果读取失败，直接返回原文件
          }
        };
        reader.onerror = () => {
          resolve(file); // 如果读取失败，直接返回原文件
        };
      })
    },
    async beforeUpload(file) {
      this.$refs.uploadRef.clearFiles();
      return new Promise((resolve, reject) => {
        this.compressImage(file).then(result => {
          this.compressedFile = result;
          resolve(true);
        }).catch(() => reject())
      })
    },
    async handleImageUpload({ file }) {
      const uploadFile = this.compressedFile || file; // 用压缩后的
      this.compressedFile = null; // 用完清掉
      this.uploading = true;
      try {
        const platform = this.activeName === 'taobao' || this.$route.query.platform === 'taobao'
          ? 'taobao'
          : '1688';
        imageSearchCache.file = uploadFile;
        imageSearchCache.imageIds = {
          '1688': null,
          taobao: null
        };
        const imgId = await this.uploadImage(uploadFile, platform);
        if (imgId) {
          this.formdata.keywords = '';
          const isReplace = this.$route.path === '/cartDetail';
          const routeMethod = isReplace ? 'replace' : 'push';
          await this.$router[routeMethod]({
            name: "cartDetail",
            query: { imgId: encodeURI(imgId), platform },
          });
        } else {
          this.$message.error(this.$t("error"));
        }
      } catch (e) {
        this.$message.error(this.$t("error"));
      } finally {
        this.uploading = false;
      }
    },
    async uploadImage(file, platform) {
      const formdata = new FormData();
      formdata.append("file", file);
      formdata.append("modular", "shopmall");
      formdata.append("type", undefined);
      const uploadApi = platform === 'taobao'
        ? 'taobaoShop/uploadByAll'
        : 'shop/1688/goods/uploadByAll';
      const res = await this.$http.post(uploadApi, formdata);
      if (res.data.code !== 200) {
        throw new Error(res.data.message || 'image upload failed');
      }
      const imgId = platform === 'taobao'
        ? res.data.data.tb
        : res.data.data['1688'];
      if (!imgId) {
        throw new Error('image id is empty');
      }
      imageSearchCache.file = file;
      imageSearchCache.imageIds[platform] = imgId;
      return imgId;
    },
    hasImageFile() {
      return !!imageSearchCache.file;
    },
    async switchImagePlatform(platform) {
      if (!imageSearchCache.file) {
        return null;
      }
      if (imageSearchCache.imageIds[platform]) {
        return imageSearchCache.imageIds[platform];
      }
      this.uploading = true;
      try {
        return await this.uploadImage(imageSearchCache.file, platform);
      } finally {
        this.uploading = false;
      }
    },
  }
};
</script>
<style lang="less" scoped>
.search {
  width: 590px;
  margin: 0 auto 8px;
  flex-shrink: 0;

  .search-bar-main {
    background-color: var(--bg-input);
    height: 38px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50px;
    border: 1px solid var(--btn-tool-hover-border);

    .search-bar {
      height: 34px;
      width: 100%;
      border-radius: 40px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-direction: row;
      padding: 0 2px;
      overflow: hidden;

      .search-icon {
        cursor: pointer;
      }

      .camera-icon {
        font-size: 20px;
        color: #1481d1;

        &.is-loading {
          opacity: 0.5;
          cursor: not-allowed;
        }
      }

      .right-search-btn {
        height: 35px;
        display: flex;
        justify-content: center;
        align-items: center;
        min-width: 6rem;
        width: auto;
        border-radius: 30px;
        margin-left: 3px;
        cursor: pointer;
      }

      /deep/ .el-input__inner {
        border: none !important;
        height: 34px;
        line-height: 34px;
      }
    }
  }

  .recent-search {
    height: 18px;
    margin-top: 4px;
    display: flex;
    align-items: center;
    overflow: hidden;

    .recent-label {
      flex: 0 0 auto;
      margin-right: 6px;
      color: var(--text-secondary, #999);
      font-size: 12px;
      white-space: nowrap;
    }

    .recent-tags {
      display: flex;
      flex-wrap: nowrap;
      gap: 8px;
      min-width: 0;
      overflow: hidden;

      .recent-tag {
        display: inline-block;
        flex: 0 0 auto;
        max-width: 120px;
        padding: 2px 0;
        color: var(--text-main);
        font-size: 12px;
        cursor: pointer;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        &:hover {
          color: #1481d1;
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .search {
    width: calc(100% - 20px);
  }
}
</style>
